import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Layout from '../../components/Layout/Layout';
import { useQuery } from '../../hooks';
import ImportUsersPreview from './ImportUsersPreview';
import ImportEstablishmentsPreview from './ImportEstablishmentsPreview';
import ImportStudentsPreview from './ImportStudentsPreview';

function UploadPreview() {
  const queryParams = useQuery();
  const importType = queryParams.get('import_type');

  const content = {
    users: <ImportUsersPreview />,
    establishments: <ImportEstablishmentsPreview />,
    students: <ImportStudentsPreview />
  };

  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col role="main">{content[importType]}</Col>
        </Row>
      </Container>
    </Layout>
  );
}

export default UploadPreview;
